@if (isStandardView) {
  <div id="itemContainer" class="item-container" #itemContainer [@comeUp]>
    @if ((data && unfilteredData.length !== 0) || !data) {
      @for (item of unfilteredData; track item) {
        <app-admin-responsible-item (click)="goToResponsible(item)" [item]="item" [index]="$index" [style.height.px]="itemWidth" />
      }
    } @else {
      <div class="no-data-container">
        <fa-icon [icon]="['fas', 'baby']" size="2x"></fa-icon>
        <span>{{ "default.buttons.noData" | translate }}</span>
      </div>
    }
  </div>
} @else if (isInfoView) {
  <app-admin-responsible-info />
} @else if (isCreateView) {
  <app-admin-responsible-create />
} @else if (isEditView) {
  <app-admin-responsible-edit />
}
